import { render } from "./Day.vue?vue&type=template&id=38347187&scoped=true&ts=true"
import script from "./Day.vue?vue&type=script&lang=ts"
export * from "./Day.vue?vue&type=script&lang=ts"

import "./Day.vue?vue&type=style&index=0&id=38347187&scoped=true&lang=less"

import exportComponent from "/var/jenkins_home/workspace/mobile-mpe-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38347187"]])

export default __exports__